(() => {
  const selector = '[data-barena-bis-variant]';
  let pendingRequest = 0;

  async function openNotification(element) {
    const variantId = Number(element.dataset.barenaBisVariant);

    if (!Number.isSafeInteger(variantId) || variantId <= 0) return;

    const request = ++pendingRequest;
    element.setAttribute('aria-busy', 'true');

    try {
      // Attende Amp se il suo script sta ancora caricando.
      for (let attempt = 0; attempt < 40; attempt++) {
        if (request !== pendingRequest) return;

        if (typeof window.BIS?.popup?.show === 'function') {
          window.BIS.popup.show({ variantId });
          return;
        }

        await new Promise(resolve => setTimeout(resolve, 200));
      }

      const italian = document.documentElement.lang.startsWith('it');

      window.alert(
        italian
          ? 'Il modulo di notifica non è disponibile. Riprova tra qualche istante.'
          : 'The notification form is unavailable. Please try again shortly.'
      );
    } finally {
      element.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', event => {
    const element = event.target.closest?.(selector);

    if (element) {
      event.preventDefault();
      event.stopPropagation();
      openNotification(element);
    } else if (event.target.closest?.('variant-picker')) {
      // Annulla un'apertura in attesa se si sceglie un'altra opzione.
      pendingRequest++;
    }
  }, true);

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      pendingRequest++;
      return;
    }

    if (event.key !== 'Enter' && event.key !== ' ') return;

    const element = event.target.closest?.(selector);

    if (!element || event.repeat) return;

    event.preventDefault();
    event.stopPropagation();
    openNotification(element);
  }, true);
})();
/* Chiude Amp cliccando fuori dal pannello o premendo Esc. */
(() => {
  const observedFrames = new WeakSet();
  const boundDocuments = new WeakSet();

  function closePopup() {
    if (typeof window.BIS?.popup?.hide === 'function') {
      window.BIS.popup.hide();
    }
  }

  function bindFrameDocument(frame) {
    try {
      const frameDocument = frame.contentDocument;

      if (!frameDocument || boundDocuments.has(frameDocument)) return;

      boundDocuments.add(frameDocument);

      frameDocument.addEventListener('click', event => {
        const panel = frameDocument.querySelector(
          '#BISModal .modal-content'
        );

        if (!panel || panel.getClientRects().length === 0) return;

        // Qualsiasi clic dentro il pannello resta invariato.
        if (panel.contains(event.target)) return;

        // Chiude solo se il clic è anche geometricamente fuori.
        const bounds = panel.getBoundingClientRect();
        const outside =
          event.clientX < bounds.left ||
          event.clientX > bounds.right ||
          event.clientY < bounds.top ||
          event.clientY > bounds.bottom;

        if (outside) closePopup();
      });

      frameDocument.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;

        event.preventDefault();
        closePopup();
      });
    } catch {
      // L’accesso richiede che l’iframe sia della stessa origine,
      // come l’iframe about:blank mostrato nel tuo Inspector.
    }
  }

  function connectFrame() {
    const frame = document.getElementById('BIS_frame');

    if (!frame) return;

    if (!observedFrames.has(frame)) {
      observedFrames.add(frame);

      frame.addEventListener('load', () => {
        bindFrameDocument(frame);
      });
    }

    bindFrameDocument(frame);
  }

  // Amp può creare o sostituire l’iframe dopo il clic sulla taglia.
  const observer = new MutationObserver(connectFrame);

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') closePopup();
  });

  connectFrame();
})();